import React, { useState } from "react";

// interfaces
import { ReferenciaContenido } from "../../../interfaces/ReferenciaContenido";

// Compontents //
import TitleSection from "../../molecules/title-section";
import FeaturesToMeetBox from "../../molecules/features-to-meet-box/featuresToMeetBox";

// Styles
import "./featuresToMeet.scss";

const FeaturesToMeet = (props: ReferenciaContenido) => {
    const { 
        tituloGeneral, 
        referenciaPlantillaContenido: refPlantilla
    } = props;

    const [showList, setShowList] = useState(0);
    
    return (
        <div className="o-features-to-meet">
            <div className="o-features-to-meet__title">
                <TitleSection
                    title={`${tituloGeneral}`}
                    type="h1"
                />
            </div>
            <div className="o-features-to-meet__container">
                {refPlantilla.map((item, index) => (
                    <FeaturesToMeetBox
                        key={index}
                        canApply={item.tipoTitulo === "true"}
                        featureList = {item.referenciaContenido}
                        title={item.tituloDescripcion}
                        showIndex={showList === index}
                        setShowList={setShowList}
                        index={index}
                    />
                ))}
            </div>
        </div>
    );
};

export default FeaturesToMeet;
